import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {getClientsList, getDesignersrsList, getManagersList} from "../api/FakeServices/catalogsService";
import {fetchList, fetchListNew} from "../hook/axios.hook";

const initialState = {
  catalogsLoading: false,
  error: null,
  managersCatalog: [],
  clientsCatalog: [],
  designers: [],
  designerTypes: [],
  agents: [],
  agentTypes: [],
  orgStructures: [],
  countries: [],
  banks: [],
  saleRulesTypes: [],
  coefTypes: [],
  paymentSchemes: [],
  finitures: [],
  factoryTypes: [],
};

export const fetchManagersCatalog = createAsyncThunk("catalogs/fetchManagersCatalog", async () => {
  const responce = getManagersList();
  return responce;
});
export const fetchClientsCatalog = createAsyncThunk("catalogs/fetchClientsCatalog ", async () => {
  const responce = getClientsList();
  return responce;
});
export const fetchDesignersCatalog = createAsyncThunk("catalogs/fetchDesignersCatalog", async () => {
  const responce = getDesignersrsList();
  return responce;
});

export const fetchOrgStructures = createAsyncThunk("catalogs/fetchOrgStructures", async () => {
  const responce = fetchList("/orgStructure/getAll", "get");
  return responce;
});

export const fetchDesigners = createAsyncThunk("catalogs/fetchDesigners", async () => {
  const responce = fetchList("/designer/getAll", "get");
  return responce;
});
export const fetchDesignerTypes = createAsyncThunk("person/fetchDesignerTypes", async () => {
  return fetchList("/designer/types/getAll", "get");
});
export const fetchAgents = createAsyncThunk("person/fetchAgents", async () => {
  return fetchList("/agent/getAll", "get");
});
export const fetchAgentTypes = createAsyncThunk("person/fetchAgentTypes", async () => {
  return fetchList("/agent/types/getAll", "get");
});

export const fetchAllCountries = createAsyncThunk("references/fetchAllCountries", async required => {
  return fetchList("/references/countries", "get", {params: {required}});
});

export const fetchBanks = createAsyncThunk("references/fetchBanks", async () => {
  return fetchList("/references/banks", "get");
});

export const fetchCoeficientTypes = createAsyncThunk("references/fetchCoeficientTypes", async () =>
  fetchList("/references/coeficientTypes", "get"),
);
export const fetchCoeficientTypesV2 = createAsyncThunk("references/fetchCoeficientTypesV2", async params =>
  fetchList("/references/coeficientTypes", "get", {params}),
);

export const fetchSaleRulesTypes = createAsyncThunk("references/fetchSaleRulesTypes", async coeficientTypeId =>
  fetchList("/references/saleRulesTypes", "get", {params: {coeficientTypeId}}),
);
export const fetchPaymentSchemes = createAsyncThunk("referens/fetchPaymentSchemes", async () =>
  fetchList("/references/paymentSchemas", "get"),
);
export const fetchFinitures = createAsyncThunk("references/fetchFinitures", async factoryId =>
  fetchListNew(`/references/finitures/${factoryId}`, "get"),
);

export const fetchFactoryTypes = createAsyncThunk("/references/fetchFactoryTypes", async ({signal}) =>
  fetchListNew("/references/factoryGroups", "get", {signal}),
);

const projectSlice = createSlice({
  name: "catalogs",
  initialState,
  reducers: {
    orgStructuresFetched: (state, {payload}) => {
      state.orgStructures = payload;
    },
    designersFetched: (state, {payload}) => {
      state.designers = payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchOrgStructures.pending, state => {
        state.catalogsLoading = true;
      })
      .addCase(fetchOrgStructures.fulfilled, (state, action) => {
        state.catalogsLoading = false;
        state.orgStructures = action.payload;
      })
      .addCase(fetchOrgStructures.rejected, (state, {error}) => {
        state.catalogsLoading = false;
        state.error = error;
      })

      .addCase(fetchDesigners.pending, state => {
        state.catalogsLoading = true;
      })
      .addCase(fetchDesigners.fulfilled, (state, action) => {
        state.catalogsLoading = false;
        state.designers = action.payload;
      })
      .addCase(fetchDesigners.rejected, (state, {error}) => {
        state.catalogsLoading = false;
        state.error = error;
      })
      .addCase(fetchDesignerTypes.fulfilled, (state, {payload}) => {
        state.designerTypes = payload;
      })
      .addCase(fetchAgents.fulfilled, (state, {payload}) => {
        state.agents = payload;
      })
      .addCase(fetchAgentTypes.fulfilled, (state, {payload}) => {
        state.agentTypes = payload;
      })

      .addCase(fetchManagersCatalog.fulfilled, (state, action) => {
        state.managersCatalog = action.payload;
      })
      .addCase(fetchClientsCatalog.fulfilled, (state, action) => {
        state.clientsCatalog = action.payload;
      })
      .addCase(fetchDesignersCatalog.fulfilled, (state, action) => {
        state.designersCatalog = action.payload;
      })

      .addCase(fetchAllCountries.fulfilled, (state, {payload}) => {
        state.countries = payload;
      })
      .addCase(fetchBanks.fulfilled, (state, {payload}) => {
        state.banks = payload;
      })
      .addCase(fetchCoeficientTypes.fulfilled, (state, {payload}) => {
        state.coefTypes = payload;
      })
      .addCase(fetchCoeficientTypesV2.fulfilled, (state, {payload}) => {
        state.coefTypes = payload;
      })
      .addCase(fetchSaleRulesTypes.fulfilled, (state, {payload}) => {
        state.saleRulesTypes = payload;
      })
      .addCase(fetchPaymentSchemes.fulfilled, (state, {payload}) => {
        state.paymentSchemes = payload;
      })
      .addCase(fetchFinitures.fulfilled, (state, {payload}) => {
        if (!payload) return;
        state.finitures = payload;
      })

      .addCase(fetchFactoryTypes.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.factoryTypes = payload;
      })

      .addDefaultCase(() => {});
  },
});

const {actions, reducer} = projectSlice;

export default reducer;
export const {orgStructuresFetched, designersFetched} = actions;

export const getOrgStructuresList = state => {
  return state.catalogs.orgStructures.map(item => {
    return {
      value: item.fullName,
      orgShortName: item.shortName,
      orgStructureId: item.orgStructureId,
    };
  });
};
export const getOrgStructuresCodeList = state => {
  return state.catalogs.orgStructures.map(item => {
    return {
      value: item.shortName,
      orgFullName: item.fullName,
      orgStructureId: item.orgStructureId,
    };
  });
};

export const getOrgStructures = state => state.catalogs.orgStructures;
export const getCatalogsLoading = state => state.catalogs.catalogsLoading;
export const selectDesignerTypes = state => state.catalogs.designerTypes;
export const selectAgents = state => state.catalogs.agents;
export const selectAgentTypes = state => state.catalogs.agentTypes;
export const selectDesigners = state => state.catalogs.designers;
export const selectAllCountries = state => state.catalogs.countries;
export const selectBanks = state => state.catalogs.banks;
export const selectSaleRulesTypes = state => state.catalogs.saleRulesTypes;
export const selectCoefTypes = state => state.catalogs.coefTypes;
export const selectPaymentSchemes = state => state.catalogs.paymentSchemes;
export const selectFinitures = state => state.catalogs.finitures;
export const selectFactoryTypes = state => state.catalogs.factoryTypes;
